/**
 * Der Start.
 *
 * Die Reihenfolge der Umhüllungen ist nicht beliebig:
 * Fehlergrenze ganz außen, damit auch ein Absturz in der Anmeldung noch eine
 * lesbare Seite ergibt. Danach der Router, danach die Sitzung — die Sitzung
 * braucht den Router nicht, aber die Bildschirme darin brauchen beides.
 *
 * Kein StrictMode: Er ruft Effekte doppelt auf, was hier bedeutet, dass jede
 * Seite ihre Daten zweimal lädt und die Rollenprüfung doppelt läuft. Beim
 * Suchen echter Fehler stört das mehr, als es hilft.
 */

import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { SitzungAnbieter } from './anmeldung/Sitzung';
import { Fehlergrenze } from './Fehlergrenze';
import './gestaltung/grundlagen.css';

const wurzel = document.getElementById('wurzel');
if (!wurzel) throw new Error('Der Anker #wurzel fehlt in index.html.');

createRoot(wurzel).render(
  <Fehlergrenze>
    <BrowserRouter>
      <SitzungAnbieter>
        <App />
      </SitzungAnbieter>
    </BrowserRouter>
  </Fehlergrenze>,
);
